import React, { useEffect, useState } from "react";
import { X, Cookie } from "lucide-react";

const STORAGE_KEY = "freeayto_cookie_consent_v1";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      // small delay so it doesn't fight the hero animation
      const t = setTimeout(() => setVisible(true), 1400);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (value) => {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ choice: value, at: new Date().toISOString() })
    );
    // Notify GoogleAnalytics + other consent-aware listeners in same tab
    try {
      window.dispatchEvent(
        new CustomEvent("freeayto:consent-updated", { detail: { choice: value } })
      );
    } catch {
      /* older browsers */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 inset-x-4 md:bottom-6 md:right-6 md:inset-x-auto md:max-w-[420px] z-[70] rounded-3xl bg-neutral-950/95 backdrop-blur-xl border border-white/10 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)] p-6 text-white animate-fade-up-slow"
      data-testid="cookie-consent-banner"
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-pink-500 via-orange-500 to-purple-500 flex items-center justify-center">
          <Cookie size={18} className="text-white" />
        </div>
        <div className="flex-1">
          <h3 className="font-display font-extrabold text-base tracking-tight">
            Wir nutzen Cookies
          </h3>
          <p className="mt-2 text-xs text-neutral-400 leading-relaxed">
            Um dir die beste Experience zu bieten, verwenden wir Cookies für Analyse,
            Performance und Newsletter-Anmeldungen. Details in unserer{" "}
            <a href="/datenschutz" className="text-pink-400 hover:text-pink-300 underline">
              Datenschutzerklärung
            </a>
            .
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={() => decide("accepted")}
              className="px-4 py-2 rounded-full bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 text-white text-[11px] font-bold uppercase tracking-[0.14em] hover:shadow-[0_10px_30px_-10px_rgba(236,72,153,0.6)] transition-shadow"
              data-testid="cookie-accept-button"
            >
              Alle akzeptieren
            </button>
            <button
              onClick={() => decide("essential")}
              className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-neutral-200 text-[11px] font-bold uppercase tracking-[0.14em] hover:bg-white/10 transition-colors"
              data-testid="cookie-essential-button"
            >
              Nur Essentielle
            </button>
          </div>
        </div>
        <button
          onClick={() => decide("dismissed")}
          className="shrink-0 -mt-1 -mr-1 text-neutral-500 hover:text-white transition-colors"
          aria-label="Cookie Hinweis schließen"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
